import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";
import { Table, Container, Row, Col, Button, Form, InputGroup, Navbar, Nav } from "react-bootstrap";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import '../css/DistributionCards.css';
import Footer from './Footer';
import { MdDelete } from "react-icons/md";

import { useDistributionsContext } from "../hooks/useDistributionsContext"
import { useEffect, useState } from "react";
import { useAuthContext } from '../hooks/useAuthContext';

function DistributionCards() {

    const { user } = useAuthContext()
    // delete
    const [delDistributionID, setdelDistributionID] = useState('')

    const { distributions, dispatch } = useDistributionsContext()

    useEffect(() => {
        const fetchDistributions = async () => {
            const response = await fetch('/api/distributions')
            const json = await response.json()

            if (response.ok) {
                dispatch({ type: 'SET_DISTRIBUTIONS', payload: json })
            }
        }

        fetchDistributions()

    }, [dispatch])


    // Handle delete ================================================

    const handleDelete = async (e, id) => {



        const response = await fetch('/api/distributions/' + id, {
            method: 'DELETE'
        })
        const json = await response.json()

        if (response.ok) {
            dispatch({ type: 'DELETE_DISTRIBUTION', payload: json })

        }

    }


    //=================================================================





    return (


        <div>

            {/* -------------------------------------------------- */}
            {/* ---------- ####### NAV BAR START #######---------- */}
            {/* -------------------------------------------------- */}
            <Navbar collapseOnSelect expand="lg" variant="dark" sticky="top" className='nav-bar-edit'>
                <Container>
                    <Navbar.Brand>Distribution Cards</Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto"></Nav>
                        <Nav>
                            {user && (
                                <div>
                                    <Navbar.Text className="nav-component nav-user-name-emp">
                                        <b>Signed as: </b> {user.email}
                                    </Navbar.Text>
                                    <Navbar.Text className="nav-component nav-user-name-emp">
                                        <b>Role: </b> {user.role}
                                    </Navbar.Text>
                                </div>
                            )}
                            <Link to="/dashboard" className="btn btn-primary mr-2 nav-component nav-link-btn ">Dashboard</Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            {/* ------------------------------------------------ */}
            {/* ---------- ####### NAV BAR END #######---------- */}
            {/* ------------------------------------------------ */}



            <div className='content'>

                <h1 className='table-name'>
                    <span>Distribution Cards</span>
                </h1>
                <h2 className='table-info'>

                </h2>



                {/* ---------------------------------------------------------------------- */}
                {/* ---------- ####### ENTIRE CARD ROW START - 4 PER ROW #######---------- */}
                {/* ---------------------------------------------------------------------- */}
                <div className="card-wrapper card-full-section">
                    <div className='row card-row'>

                        {distributions && distributions.map((distribution) => (
                            <div className="col-sm-3 card-section-full">
                                <div className="card">

                                    <div>

                                        {/* Date */}
                                        <h1 className="text-center product-name">{distribution.date}</h1>

                                        <div className='row row-section'>

                                            {/* TIME */}
                                            <div className='col text-center'>
                                                <h2 className="name">Time</h2>
                                                <p className="description">
                                                    {distribution.time}
                                                </p>
                                            </div>

                                            {/* CATEGORY */}
                                            <div className='col text-center'>
                                                <h2 className="name">Category</h2>
                                                <p className="description">
                                                    {distribution.category}
                                                </p>
                                            </div>
                                        </div>

                                        <div className='row row-section'>

                                            {/* Batch No */}
                                            <div className='col text-center'>
                                                <h2 className="name">Batch No : </h2>
                                                <p className="description">
                                                    {distribution.batchNo}
                                                </p>
                                            </div>

                                            {/* QUABTITY */}
                                            <div className='col text-center'>
                                                <h2 className="name">Quantity</h2>
                                                <p className="description">
                                                    {distribution.quantity}
                                                </p>
                                            </div>
                                        </div>



                                        <div className='row row-section'>

                                            {/* LOCATION */}
                                            <div className='col text-center'>
                                                <h2 className="name">Location</h2>
                                                <p className="description">
                                                    {distribution.locate}
                                                </p>
                                            </div>

                                            {/* DISTANCE */}
                                            <div className='col text-center'>
                                                <h2 className="name">Distance</h2>
                                                <p className="description">
                                                    {distribution.distance}
                                                </p>
                                            </div>
                                        </div>







                                        <div className='row row-section'>

                                            {/* DURATION */}
                                            <div className='col text-center'>
                                                <h2 className="name">Duration</h2>
                                                <p className="description">
                                                    {distribution.duration}
                                                </p>
                                            </div>

                                            {/* DRIVER ID */}
                                            <div className='col text-center'>
                                                <h2 className="name">Driver ID</h2>
                                                <p className="description">
                                                    {distribution.driverID}
                                                </p>
                                            </div>
                                        </div>



                                        <div className='text-center'>

                                            <button className="button delete-btn-d" onClick={e => { handleDelete(e, distribution._id); setdelDistributionID(e, distribution._id) }}><MdDelete className='delete-btn-icon' />  Delete</button>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
                </div>
                {/* -------------------------------------------------------------------- */}
                {/* ---------- ####### ENTIRE CARD ROW END - 4 PER ROW #######---------- */}
                {/* -------------------------------------------------------------------- */}


            </div>
            <Footer />
        </div>


    )
}

export default DistributionCards